import { Form, Formik } from 'formik';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { initialValues, onSubmit, validationSchema } from './loginFormikCodes.js';
import GetField from '../../components/GetField.jsx';
import PsychologyIcon from '@mui/icons-material/Psychology';

const AdminLogin = () => {
    const navigate = useNavigate();

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, actions) => onSubmit(values, actions, navigate)}
            validationSchema={validationSchema}
            validateOnMount
        >
            {(formik) => {
                return (
                    <Form className="flex flex-col items-center px-2 py-3">
                        <div>
                            <PsychologyIcon sx={{ fontSize: "2.5rem" }} />
                        </div>
                        <h2 className="text-lg mb-5">ورود ادمین</h2>
                        <div className="mb-4 w-full sm:w-3/4 md:w-3/5 max-w-screen-sm">
                            <GetField
                                control="input"
                                name="email_or_phone"
                                type="text"
                                placeholder="ایمیل یا شماره تلفن"
                                formik={formik}
                                fieldClass="dir-ltr"
                            />
                        </div>
                        <div className="mb-4 w-full sm:w-3/4 md:w-3/5 max-w-screen-sm">
                            <GetField
                                control="password"
                                name="password"
                                placeholder="رمز عبور"
                                formik={formik}
                            />
                        </div>
                        <div className="mb-4 w-full sm:w-3/4 md:w-3/5 max-w-screen-sm">
                            <a
                                href="http://app.wisercam.com/login"
                                target="_blank"
                                rel="noreferrer"
                                className="text-primary hover:underline"
                            >
                                رمز عبور خود را فراموش کرده اید؟
                            </a>
                        </div>
                        <div className="w-full text-center mt-4">
                            <GetField
                                control="submitbutton"
                                disabledButton={true}
                                formik={formik}
                                text={"ورود"}
                            />
                        </div>
                    </Form>
                );
            }}
        </Formik>
    );
}

export default AdminLogin;
